module.exports = __webpack_public_path__ + "img/walk.cfd9fc64.svg";